import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { style: { "line-height": "60px", "font-size": "40px", "margin-bottom": "40px" } }, " 创作者中心 ", -1);
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("登陆系统");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_van_button = _resolveComponent("van-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_van_button, {
            type: "primary",
            round: "",
            block: "",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.router('/login')))
        }, {
            default: _withCtx(() => [
                _hoisted_3
            ]),
            _: 1
        })
    ]));
}
